<template>
    <nav
        class="flex-shrink-0 space-y-10 bg-white px-6 py-8 lg:py-12 md:overflow-y-auto no-scrollbar"
    >
        <div v-for="type in types" :key="type.id">
            <h3 class="text-sm font-medium tracking-wide text-gray-500 uppercase">
                {{ $l({ en: type.titleEn, pl: type.titlePl }) }}
            </h3>
            <ul role="list" class="mt-5 space-y-6">
                <li
                    v-for="category in categories.filter((x) => x.type == type.id)"
                    :key="category.id"
                    class="flow-root"
                >
                    <a
                        href=""
                        @click.prevent="$emit('selectCategory', category)"
                        :class="[selected.id == category.id ? 'bg-gray-100' : '']"
                        class="-m-3 p-3 flex items-center rounded-md text-sm font-medium text-gray-900 hover:bg-gray-50 transition ease-in-out duration-150 group"
                    >
                        <component
                            :is="category.icon + 'Icon'"
                            class="flex-shrink-0 h-5 w-5 text-gray-400 group-hover:text-gray-500"
                        ></component>

                        <div class="flex justify-between items-center w-full">
                            <span class="ml-4">
                                {{ $l({ en: category.nameEn, pl: category.namePl }) }}
                            </span>
                            <span
                                v-if="admin"
                                class="ml-4 text-gray-400 hover:text-gray-500"
                                @click="deleteCategory(category.id)"
                            >
                                <TrashBinIcon class="h-4 w-4" />
                            </span>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
        <ButtonSecondarySm v-if="admin && !addMode" @click.prevent="turnOnAddMode">
            <AddIcon />
            {{ $l({ en: "Add category", pl: "Dodaj kategorię" }) }}
        </ButtonSecondarySm>

        <div v-if="addMode" class="space-y-2">
            <FormInput title="Podaj nazwę PL" v-model="newCat.namePl" />
            <FormInput title="Podaj nazwę EN" v-model="newCat.nameEn" />
            <FormInput title="Podaj ikonę" v-model="newCat.icon" />
            <c-select
                class="text-left"
                :label="$l({ en: 'Chose type', pl: 'Podaj typ' })"
                :list="types"
                v-model="newCat.type"
            />

            <div class="flex justify-between flex-col sm:flex-row-reverse">
                <ButtonPrimarySm @click="addCategory">
                    {{ $t("shared.save") }}
                </ButtonPrimarySm>
                <ButtonSecondarySm @click="addMode = false">
                    {{ $t("shared.cancel") }}
                </ButtonSecondarySm>
            </div>
        </div>
    </nav>
</template>

<script>
import { ButtonPrimarySm, ButtonSecondarySm } from "@easy/ui/buttons";
import { AddIcon } from "@easy/ui/icons";
import { FormInput } from "@easy/ui/forms";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import cSelect from "@/apps/banner/components/cSelect.vue";
// import Query from "@/shared/js/query";

import {
    BookIcon,
    CoinsHandIcon,
    UserMultipleIcon,
    BusinessHandshakeIcon,
    PricingIcon,
    UserCircleSingleIcon,
    LoveIcon,
    TrashBinIcon,
} from "@easy/ui/icons";

export default {
    name: "Categories",
    props: {
        selected: Object,
    },
    data() {
        return {
            addMode: false,
            newCat: {
                namePl: "",
                nameEn: "",
                icon: "",
                type: "",
            },
            admin: true,
        };
    },
    components: {
        ButtonPrimarySm,
        ButtonSecondarySm,
        AddIcon,
        FormInput,
        cSelect,
        LoveIcon,
        BookIcon,
        CoinsHandIcon,
        UserCircleSingleIcon,
        UserMultipleIcon,
        BusinessHandshakeIcon,
        PricingIcon,
        TrashBinIcon,
    },
    emits: ["selectCategory"],
    computed: {
        ...mapState("banner/categories", ["categories"]),
        ...mapGetters("banner/categories", ["types"]),
    },
    mounted() {
        // this.$emit(
        //     "selectCategory",
        //     this.categories.find((x) => x.namePl === "Social Media")
        // );
        // const query = new Query(window.location.search);
        // this.admin = !!query.get("admin");
    },
    methods: {
        ...mapMutations(["showModal"]),
        ...mapActions("banner/categories", ["createCategory", "removeCategory"]),
        turnOnAddMode() {
            this.addMode = true;
        },
        addCategory() {
            this.createCategory(this.newCat);
            this.addMode = false;
        },
        deleteCategory(id) {
            this.showModal({
                type: "confirm",
                title: this.$l({
                    en: "Deleting category",
                    pl: "Usuwasz kategorię!",
                }),
                desc: this.$l({
                    en: "Do you really want to remove this category ?",
                    pl: "Czy chcesz usunąć tą kategorię?",
                }),
                cancelBtn: this.$l({
                    en: "Cancel",
                    pl: "Anuluj",
                }),
                actionBtn: this.$l({
                    en: "Delete",
                    pl: "Usuń",
                }),

                callback: () => {
                    this.removeCategory(id);
                },
            });
        },
    },
};
</script>
